import { CUSTOM_BEHAVIORAL_EVENT } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { Map as ImmutableMap, Record } from 'immutable';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
export const CustomBehavioralEventRecord = Record({
  fullyQualifiedName: '',
  objectTypeId: '',
  label: '',
  primaryObjectTypeId: undefined
});
export class CustomBehavioralEventsAdapterConfig extends HttpAdapterConfig {
  constructor(...args) {
    super(...args);
    this.performanceTrackingKey = 'CustomBehavioralEventsAdapterConfig';
  }
  getCacheKey() {
    return 'CUSTOM_BEHAVIORAL_EVENTS';
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === CUSTOM_BEHAVIORAL_EVENT;
  }
  fetchData(httpClient) {
    return httpClient('events/internal/v0/app/event-types', {
      query: {
        metaType: ['PORTAL_SPECIFIC_EVENT']
      }
    });
  }
  formatData(customBehavioralEvents) {
    return customBehavioralEvents.reduce((acc, customBehavioralEvent) => {
      const {
        eventTypeId,
        fullyQualifiedName,
        labels,
        primaryObjectTypeId
      } = customBehavioralEvent;
      const objectTypeId = `6-${eventTypeId.innerId}`;
      const label = labels.singular || fullyQualifiedName;
      return acc.set(objectTypeId, CustomBehavioralEventRecord({
        objectTypeId,
        label,
        fullyQualifiedName,
        primaryObjectTypeId
      }));
    }, ImmutableMap());
  }
}
export default Adapter.makeFromConfig(CustomBehavioralEventsAdapterConfig);